// Registro compartido de iconos para Servicios (config del Tenant + Terminal).
// Cada servicio guarda una CLAVE de icono; aquí se resuelve al componente lucide.
import {
  Wrench, Droplets, Bath, Droplet, Disc3, BatteryCharging, Sparkles, Car,
  SprayCan, Fuel, Wind, Scissors, ShieldCheck, Key, Package,
} from "lucide-react";

const REGISTRY = {
  generic: Wrench,
  carwash: Droplets,
  bath: Bath,
  wrench: Wrench,
  oil: Droplet,
  tire: Disc3,
  battery: BatteryCharging,
  detailing: Sparkles,
  car: Car,
  cleaning: SprayCan,
  fuel: Fuel,
  dry: Wind,
  scissors: Scissors,
  shield: ShieldCheck,
  key: Key,
  package: Package,
};

// Colección visual para el selector (orden pensado para servicios habituales).
export const ICON_OPTIONS = [
  { key: "generic", label: "Servicio", Icon: Wrench },
  { key: "carwash", label: "Autolavado", Icon: Droplets },
  { key: "bath", label: "Baños", Icon: Bath },
  { key: "wrench", label: "Mecánica", Icon: Wrench },
  { key: "oil", label: "Cambio de aceite", Icon: Droplet },
  { key: "tire", label: "Llantas", Icon: Disc3 },
  { key: "battery", label: "Batería", Icon: BatteryCharging },
  { key: "detailing", label: "Detallado", Icon: Sparkles },
  { key: "car", label: "Auto", Icon: Car },
  { key: "cleaning", label: "Limpieza", Icon: SprayCan },
  { key: "fuel", label: "Combustible", Icon: Fuel },
  { key: "dry", label: "Secado", Icon: Wind },
  { key: "scissors", label: "Estética", Icon: Scissors },
  { key: "shield", label: "Seguro", Icon: ShieldCheck },
  { key: "key", label: "Llaves", Icon: Key },
  { key: "package", label: "Paquete", Icon: Package },
];

// Devuelve el componente de icono para una clave, con respaldo genérico.
export const getServiceIcon = (key) => REGISTRY[key] || Wrench;

const _norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

// Sugerencia automática por nombre (el Tenant siempre puede cambiarla).
export const suggestServiceIcon = (nombre) => {
  const n = _norm(nombre);
  if (!n) return "generic";
  const has = (...ws) => ws.some((w) => n.includes(w));
  if (has("aceite", "lubric", "oil")) return "oil";
  if (has("lavad", "lava", "wash", "agua", "encer")) return "carwash";
  if (has("bano", "sanit", "wc", "toilet", "regader")) return "bath";
  if (has("llant", "rueda", "neumat", "tire", "vulcan", "balance")) return "tire";
  if (has("bateri", "battery", "acumulador", "pila")) return "battery";
  if (has("detall", "brillo", "pulido", "cera", "abrillan")) return "detailing";
  if (has("secad", "secar", "dry")) return "dry";
  if (has("limpiez", "clean", "aspira", "sanitiz")) return "cleaning";
  if (has("mecan", "taller", "repar", "afinac", "frenos")) return "wrench";
  if (has("gas", "combust", "fuel", "diesel", "magna")) return "fuel";
  if (has("estetic", "corte", "peluq", "barber")) return "scissors";
  if (has("seguro", "poliza", "proteccion")) return "shield";
  if (has("llave", "duplicad", "cerraj")) return "key";
  if (has("paquete", "combo", "kit")) return "package";
  if (has("auto", "coche", "vehic", "car")) return "car";
  return "generic";
};
